module.exports = __webpack_public_path__ + "img/limit-his-land-3.76ecfe0f.jpg";